import {fxeQuiz, FxeQuiz} from "./quiz/FxeQuizComponent";
import {fxeQuizResults, FxeQuizResults} from "./results/FxeQuizResultsComponent";
import {FxeQuizService} from "./service/FxeQuizService";
import {marketMovementVol, MarketMovementVol} from "./questions/MarketMovementVol";
import {expirationExerciseAssignment1, ExpirationExerciseAssignment1} from "./questions/ExpirationExerciseAssignment1";
import {expirationExerciseAssignment2, ExpirationExerciseAssignment2} from "./questions/ExpirationExerciseAssignment2";
import {expirationExerciseAssignment3, ExpirationExerciseAssignment3} from "./questions/ExpirationExerciseAssignment3";
import {expirationExerciseAssignment4, ExpirationExerciseAssignment4} from "./questions/ExpirationExerciseAssignment4";
import {expirationExerciseAssignment5, ExpirationExerciseAssignment5} from "./questions/ExpirationExerciseAssignment5";
import {expirationExerciseAssignment6, ExpirationExerciseAssignment6} from "./questions/ExpirationExerciseAssignment6";
import {ongoingObligationsOfPositions1, OngoingObligationsOfPositions1} from "./questions/OngoingObligationsOfPositions1";
import {ongoingObligationsOfPositions2, OngoingObligationsOfPositions2} from "./questions/OngoingObligationsOfPositions2";
import {financialLoss, FinancialLoss} from "./questions/FinancialLoss";
import {leverage1, Leverage1} from "./questions/Leverage1";
import {leverage2, Leverage2} from "./questions/Leverage2";

export default angular.module("tfApp.quiz.fxe-quiz", [])
                      .component(MarketMovementVol, marketMovementVol())
                      .component(ExpirationExerciseAssignment1, expirationExerciseAssignment1())
                      .component(ExpirationExerciseAssignment2, expirationExerciseAssignment2())
                      .component(ExpirationExerciseAssignment3, expirationExerciseAssignment3())
                      .component(ExpirationExerciseAssignment4, expirationExerciseAssignment4())
                      .component(ExpirationExerciseAssignment5, expirationExerciseAssignment5())
                      .component(ExpirationExerciseAssignment6, expirationExerciseAssignment6())
                      .component(OngoingObligationsOfPositions1, ongoingObligationsOfPositions1())
                      .component(OngoingObligationsOfPositions2, ongoingObligationsOfPositions2())
                      .component(FinancialLoss, financialLoss())
                      .component(Leverage1,leverage1())
                      .component(Leverage2, leverage2())
                      .component(FxeQuiz, fxeQuiz())
                      .component(FxeQuizResults, fxeQuizResults())
                      .service(FxeQuizService.id, FxeQuizService)
                      .name;
